import { render, staticRenderFns } from "./ApprovalApplication.vue?vue&type=template&id=255c350c"
import script from "./ApprovalApplication.vue?vue&type=script&lang=js"
export * from "./ApprovalApplication.vue?vue&type=script&lang=js"
import style0 from "./ApprovalApplication.vue?vue&type=style&index=0&id=255c350c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports